const langtrans={
      fhssyy:["返回上一页","Back"],
      hffajb:["回复方案及报价详情","Reply to plan and quotation"],
      jyfa:["救援方案","Operation plan"],
      wdddbj:["我的报价","My quotation"],
      ztbtfy:["整体费用：","Total:"],
      jyfy:["救援费用：","Operation fee:"],
      ylfy:["医疗费用：","Medical cost:"],
      ajfy:["案件费用：","Case fee:"],
      gbxqq:["关闭详情","Details closed"],
      xgbjjj:["修改报价","Modify quotation"],
      bjjjyc:["报价已采纳","Quotation accepted"],
      bjjjyg:["报价已关闭","Quotation closed"],
}
export default langtrans;


// WEBPACK FOOTER //
// ./src/components/fac/js/lookinf.vue.trans.js